var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllDspIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 0.333374C0.781211 0.333374 0.333496 0.781089 0.333496 1.33337V3.33337C0.333496 3.88566 0.781211 4.33337 1.3335 4.33337H3.3335C3.88578 4.33337 4.3335 3.88566 4.3335 3.33337V1.33337C4.3335 0.781089 3.88578 0.333374 3.3335 0.333374H1.3335ZM1.3335 5.66671C0.781211 5.66671 0.333496 6.11442 0.333496 6.66671V8.66671C0.333496 9.21899 0.781211 9.66671 1.3335 9.66671H3.3335C3.88578 9.66671 4.3335 9.21899 4.3335 8.66671V6.66671C4.3335 6.11442 3.88578 5.66671 3.3335 5.66671H1.3335ZM5.66683 1.33337C5.66683 0.781089 6.11455 0.333374 6.66683 0.333374H8.66683C9.21912 0.333374 9.66683 0.781089 9.66683 1.33337V3.33337C9.66683 3.88566 9.21912 4.33337 8.66683 4.33337H6.66683C6.11455 4.33337 5.66683 3.88566 5.66683 3.33337V1.33337ZM6.66683 5.66671C6.11455 5.66671 5.66683 6.11442 5.66683 6.66671V8.66671C5.66683 9.21899 6.11455 9.66671 6.66683 9.66671H8.66683C9.21912 9.66671 9.66683 9.21899 9.66683 8.66671V6.66671C9.66683 6.11442 9.21912 5.66671 8.66683 5.66671H6.66683Z",
    fill: "#8DA5BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllDspIcon);
export default __webpack_public_path__ + "static/media/allDspIcon.a9329407.svg";
export { ForwardRef as ReactComponent };